import React from 'react';

import _ from 'es-toolkit/compat';

import { FullscreenLoader } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';
import {
  useUserEmailChangeRequestById,
  useUserEmailChangeRequestParamId,
} from 'src/hooks/userEmailChangeRequestId';

export const ChangeEmailConfirm: React.FC = () => {
  const { openModal } = useModal();

  const userEmailChangeRequestId = useUserEmailChangeRequestParamId();

  const { confirmUserEmail, loading: confirmSubmitting } =
    useUserEmailChangeRequestById(userEmailChangeRequestId);

  React.useEffect(() => {
    if (!_.isNil(userEmailChangeRequestId)) {
      confirmUserEmail()
        .then(() => {
          openModal(ModalId.UserEmailConfirmRequestFulfilled);
        })
        .catch(error => {
          console.error(error);
          openModal(ModalId.UserEmailConfirmRequestErrorModal);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (confirmSubmitting) {
    return <FullscreenLoader />;
  }

  return null;
};
